module.exports = __webpack_public_path__ + "img/refreshing-arrows-couple.45427d30.svg";